class ContactsForm {
    constructor(item) {
        // Переменные
        this.element = item;
        this.inputs = this.element.querySelectorAll('.js-contacts-form-input');
        this.placeholders = this.element.querySelectorAll('.js-contacts-form-placeholder');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.inputs.forEach((item, index) => {
            item.addEventListener('input', () => {
                this.placeholders[index].style.display = item.value == "" ? 'block' : 'none';
            });
        });
    }
};

document.querySelectorAll('.js-contacts-form').forEach((item) => new ContactsForm(item));
